import * as R from 'ramda'

import candidate_en from 'i18n/candidate_score_card.en.json'
import candidate_nb from 'i18n/candidate_score_card.nb.json'
import recruiter_en from 'i18n/recruiter_score_card.en.json'
import recruiter_nb from 'i18n/recruiter_score_card.nb.json'
import { titleCase } from 'utils/stringFormat'
import { t } from 'ttag'

export const languages = {
  en: {
    candidate: candidate_en,
    recruiter: recruiter_en,
  },
  nb: {
    candidate: candidate_nb,
    recruiter: recruiter_nb,
  },
}

export const scoreBucket = score => {
  if (score > 0.7) return ['high', t`above average`]
  if (score > 0.3) return ['mid', t`average`]
  return ['low', t`below average`]
}

const prepText = traitName => {
  const traitLabel = String(traitName ?? '')
  return R.when(
    R.is(String),
    R.pipe(
      R.defaultTo('??'),
      R.replace(/\{ *trait *\}/g, traitLabel.toLowerCase()),
      R.replace(/\{ *Trait *\}/g, titleCase(traitLabel)),
      R.split(/\s*\n\s*/),
      R.map(R.trim),
    ),
  )
}

export const translateIntro = (language = 'en', isCandidate = true) =>
  languages[language][isCandidate ? 'candidate' : 'recruiter'].intro

export const isStructuredIntro = intro =>
  Array.isArray(intro) && intro.some(section => section?.paragraphs)

export const translateTrait = (
  trait,
  score,
  language = 'en',
  isCandidate = true,
) => {
  const {
    label = '?',
    abstract,
    lowLabel,
    highLabel,
    ...text
  } = R.pathOr(
    {},
    [language, isCandidate ? 'candidate' : 'recruiter', 'traits', trait],
    languages,
  )
  const [bucket, judgement] = scoreBucket(score)
  const description =
    (isCandidate
      ? t`Your score in {trait} is ${judgement} `
      : t`The candidate's score in {trait} is ${judgement} `) +
    t`compared to other applicants who have completed the test. ` +
    (text[bucket] || '')

  return R.map(prepText(label))({
    label,
    score,
    abstract,
    lowLabel,
    highLabel,
    description,
    judgement,
  })
}

export const getFactorProps = (scores, language = 'en') =>
  R.pipe(
    R.toPairs,
    R.map(([trait, score]) => translateTrait(trait, score, language)),
  )(scores)
